module.exports = __webpack_public_path__ + "img/light.0d270cb5.svg";